import {connect} from 'react-redux';
import {getListActions, getListState} from '../../../utilites/helpers/crudListHelper';
import productActions from '../../../actions/shop/products';
import ProductGridList from './ProductGridList';
import {getCurrentClubId} from '../../../selectors/club-settings';

export default connect(
  (state) => (Object.assign(getListState(state.shop.product),{
    filter: {
      club_id: getCurrentClubId(state)
    }
  })),
  (dispatch) => getListActions(productActions, dispatch)
)(ProductGridList);



// WEBPACK FOOTER //
// ./src/components/Shop/ProductGridList/index.js